export const cacheKeys = {
  createTribute: 'createTribute',
  getTribute: 'getTribute',
  getTributes: 'getTributes',
  editTribute: 'editTribute',
  payWithCredit: 'payWithCredit',
  createParcel: 'createParcel',

  uploadMedia: 'uploadMedia',
  getMedia: 'getMedia',
  getAllMedia: 'getAllMedia',
};

export const petDetailsFormDataKey = `${import.meta.env.VITE__CVT_PROJECT_KEY}-pet-details-form-data`;
export const petDetailsIsQuickAddViewKey = `${import.meta.env.VITE__CVT_PROJECT_KEY}-pet-details-is-quick-add-view`;
export const petStoryDataKey = `${import.meta.env.VITE__CVT_PROJECT_KEY}-pet-story-form-data`;
